import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import { List, OrderedMap } from 'immutable';
import { isFunction } from 'lodash-es';
import { action, dispatch, regHandlers, regSaga } from '../../../store';
import { deserializeTree, serializeTree, Connector, TreeBuilderState } from './models';
import { cloneTree, fetchTaskCategories, fetchTree, updateTree } from '../../../apis/task';
import { renameDependencies, treeReturnTask } from './helpers';
export var mountTreeBuilder = function mountTreeBuilder(treeKey) {
  return dispatch('TREE_MOUNT', {
    treeKey: treeKey
  });
};
export var unmountTreeBuilder = function unmountTreeBuilder(treeKey) {
  return dispatch('TREE_UNMOUNT', {
    treeKey: treeKey
  });
};
export var configureTreeBuilder = function configureTreeBuilder(props) {
  return dispatch('TREE_CONFIGURE', props);
}; // Helper that adds the present state to the past stack and clears the future
// stack. This should be called by reducer cases that will be undo/redo able.

var remember = function remember(state, treeKey) {
  return state.updateIn(['trees', treeKey, 'undoStack'], function (stack) {
    return stack.push(state.getIn(['trees', treeKey, 'tree']));
  }).deleteIn(['trees', treeKey, 'redoStack']);
};

regSaga(takeEvery('TREE_CONFIGURE', /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
  var payload, name, sourceGroup, sourceName, treeKey, _yield$all, _yield$all2, tree, categories;

  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _ref.payload;
          _context.prev = 1;
          name = payload.name, sourceGroup = payload.sourceGroup, sourceName = payload.sourceName, treeKey = payload.treeKey;
          _context.next = 5;
          return all([call(fetchTree, {
            name: name,
            sourceGroup: sourceGroup,
            sourceName: sourceName,
            include: 'bindings,details,treeJson'
          }), call(fetchTaskCategories, {
            include: 'handlers.results,handlers.parameters,trees.parameters,trees.inputs,trees.outputs'
          })]);

        case 5:
          _yield$all = _context.sent;
          _yield$all2 = _slicedToArray(_yield$all, 2);
          tree = _yield$all2[0].tree;
          categories = _yield$all2[1].categories;
          _context.next = 11;
          return put(action('TREE_LOADED', {
            categories: categories,
            treeKey: treeKey,
            tree: deserializeTree(tree)
          }));

        case 11:
          _context.next = 16;
          break;

        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](1);
          console.error('Caught error loading tree', _context.t0);

        case 16:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[1, 13]]);
})));
regSaga(takeEvery('TREE_SAVE', /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
  var payload, newName, onError, onSave, overwrite, treeKey, _yield$select, tree, name, sourceGroup, sourceName, _yield, error, newTree;

  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _ref2.payload;
          _context2.prev = 1;
          // because of the optimistic locking functionality newName / overwrite can
          // be passed as options to the builder's save function
          newName = payload.newName, onError = payload.onError, onSave = payload.onSave, overwrite = payload.overwrite, treeKey = payload.treeKey;
          _context2.next = 5;
          return select(function (state) {
            return state.getIn(['trees', treeKey]);
          });

        case 5:
          _yield$select = _context2.sent;
          tree = _yield$select.tree;
          name = tree.name, sourceGroup = tree.sourceGroup, sourceName = tree.sourceName; // if a newName was passed we will be creating a new tree with the builder
          // contents, otherwise just an update

          _context2.next = 10;
          return newName ? call(cloneTree, {
            name: name,
            sourceGroup: sourceGroup,
            sourceName: sourceName,
            tree: _objectSpread({
              name: newName
            }, serializeTree(tree, true))
          }) : call(updateTree, {
            name: name,
            sourceGroup: sourceGroup,
            sourceName: sourceName,
            tree: serializeTree(tree, overwrite)
          });

        case 10:
          _yield = _context2.sent;
          error = _yield.error;
          newTree = _yield.tree;
          _context2.next = 15;
          return put(error ? action('TREE_SAVE_ERROR', {
            treeKey: treeKey,
            error: error.message || error,
            onError: onError
          }) : action('TREE_SAVE_SUCCESS', {
            treeKey: treeKey,
            tree: newTree,
            onSave: onSave
          }));

        case 15:
          _context2.next = 20;
          break;

        case 17:
          _context2.prev = 17;
          _context2.t0 = _context2["catch"](1);
          console.error(_context2.t0);

        case 20:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[1, 17]]);
})));
regSaga(takeEvery('TREE_SAVE_ERROR', /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3) {
  var _ref3$payload, error, onError;

  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _ref3$payload = _ref3.payload, error = _ref3$payload.error, onError = _ref3$payload.onError;
          _context3.prev = 1;

          if (!isFunction(onError)) {
            _context3.next = 5;
            break;
          }

          _context3.next = 5;
          return call(onError, error);

        case 5:
          _context3.next = 10;
          break;

        case 7:
          _context3.prev = 7;
          _context3.t0 = _context3["catch"](1);
          console.error(_context3.t0);

        case 10:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[1, 7]]);
})));
regSaga(takeEvery('TREE_SAVE_SUCCESS', /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref4) {
  var _ref4$payload, onSave, tree;

  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _ref4$payload = _ref4.payload, onSave = _ref4$payload.onSave, tree = _ref4$payload.tree;
          _context4.prev = 1;

          if (!isFunction(onSave)) {
            _context4.next = 5;
            break;
          }

          _context4.next = 5;
          return call(onSave, tree);

        case 5:
          _context4.next = 10;
          break;

        case 7:
          _context4.prev = 7;
          _context4.t0 = _context4["catch"](1);
          console.error(_context4.t0);

        case 10:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[1, 7]]);
})));
regHandlers({
  // the TreeBuilder component does nothing while the tree state is undefined,
  // on mount we set it to null to signal to the component to dispatch the
  // configure action with its configuration props
  TREE_MOUNT: function TREE_MOUNT(state, _ref5) {
    var treeKey = _ref5.payload.treeKey;
    return state.setIn(['trees', treeKey], null);
  },
  TREE_CONFIGURE: function TREE_CONFIGURE(state, _ref6) {
    var treeKey = _ref6.payload.treeKey;
    return state.setIn(['trees', treeKey], TreeBuilderState());
  },
  TREE_UNMOUNT: function TREE_UNMOUNT(state, _ref7) {
    var treeKey = _ref7.payload.treeKey;
    return state.deleteIn(['trees', treeKey]);
  },
  TREE_LOADED: function TREE_LOADED(state, _ref8) {
    var _ref8$payload = _ref8.payload,
        categories = _ref8$payload.categories,
        treeKey = _ref8$payload.treeKey,
        tree = _ref8$payload.tree;
    return state.mergeIn(['trees', treeKey], {
      categories: categories,
      lastSave: tree,
      loading: false,
      tasks: List(categories).map(function (category) {
        return category.name === 'System Controls' ? _objectSpread(_objectSpread({}, category), {}, {
          handlers: [].concat(_toConsumableArray(category.handlers), [treeReturnTask(tree)])
        }) : category;
      }).flatMap(function (category) {
        return [].concat(_toConsumableArray(category.handlers), _toConsumableArray(category.trees));
      }).sortBy(function (task) {
        return task.name;
      }).reduce(function (reduction, task) {
        return reduction.set(task.definitionId, task);
      }, OrderedMap()),
      tree: tree
    });
  },
  TREE_SAVE: function TREE_SAVE(state, _ref9) {
    var treeKey = _ref9.payload.treeKey;
    return state.mergeIn(['trees', treeKey], {
      saving: true
    });
  },
  TREE_SAVE_ERROR: function TREE_SAVE_ERROR(state, _ref10) {
    var _ref10$payload = _ref10.payload,
        treeKey = _ref10$payload.treeKey,
        error = _ref10$payload.error;
    return state.mergeIn(['trees', treeKey], {
      error: error,
      saving: false
    });
  },
  TREE_SAVE_SUCCESS: function TREE_SAVE_SUCCESS(state, _ref11) {
    var _ref11$payload = _ref11.payload,
        tree = _ref11$payload.tree,
        treeKey = _ref11$payload.treeKey;
    var newTree = state.getIn(['trees', treeKey, 'tree']).merge({
      name: tree.name,
      versionId: tree.versionId
    });
    return state.mergeIn(['trees', treeKey], {
      dirty: false,
      error: null,
      lastSave: newTree,
      saving: false,
      tree: newTree
    });
  },
  TREE_UNDO: function TREE_UNDO(state, _ref12) {
    var treeKey = _ref12.payload.treeKey;
    return state.getIn(['trees', treeKey, 'undoStack']).isEmpty() ? state : state.updateIn(['trees', treeKey], function (builderState) {
      return builderState.merge({
        tree: builderState.undoStack.last(),
        redoStack: builderState.redoStack.push(builderState.tree),
        undoStack: builderState.undoStack.butLast()
      });
    });
  },
  TREE_REDO: function TREE_REDO(state, _ref13) {
    var treeKey = _ref13.payload.treeKey;
    return state.getIn(['trees', treeKey, 'redoStack']).isEmpty() ? state : state.updateIn(['trees', treeKey], function (builderState) {
      return builderState.merge({
        tree: builderState.redoStack.last(),
        redoStack: builderState.redoStack.butLast(),
        undoStack: builderState.undoStack.push(builderState.tree)
      });
    });
  },
  TREE_UPDATE: function TREE_UPDATE(state, _ref14) {
    var _ref14$payload = _ref14.payload,
        tree = _ref14$payload.tree,
        treeKey = _ref14$payload.treeKey;
    return remember(state, treeKey).setIn(['trees', treeKey, 'tree'], tree);
  },
  TREE_UPDATE_NODE: function TREE_UPDATE_NODE(state, _ref15) {
    var _ref15$payload = _ref15.payload,
        treeKey = _ref15$payload.treeKey,
        id = _ref15$payload.id,
        messages = _ref15$payload.messages,
        deferrable = _ref15$payload.deferrable,
        defers = _ref15$payload.defers,
        definitionId = _ref15$payload.definitionId,
        dependencies = _ref15$payload.dependencies,
        name = _ref15$payload.name,
        parameters = _ref15$payload.parameters,
        visible = _ref15$payload.visible;
    return remember(state, treeKey).mergeIn(['trees', treeKey, 'tree', 'nodes', id], {
      deferrable: deferrable,
      defers: defers,
      definitionId: definitionId,
      messages: messages,
      name: name,
      parameters: parameters,
      visible: visible
    }).updateIn(['trees', treeKey, 'tree'], renameDependencies(dependencies, name));
  },
  TREE_UPDATE_NODE_POSITION: function TREE_UPDATE_NODE_POSITION(state, _ref16) {
    var _ref16$payload = _ref16.payload,
        treeKey = _ref16$payload.treeKey,
        id = _ref16$payload.id,
        position = _ref16$payload.position;
    return remember(state, treeKey).setIn(['trees', treeKey, 'tree', 'nodes', id, 'position'], position);
  },
  TREE_REMOVE_NODE: function TREE_REMOVE_NODE(state, _ref17) {
    var _ref17$payload = _ref17.payload,
        treeKey = _ref17$payload.treeKey,
        id = _ref17$payload.id;
    return remember(state, treeKey).deleteIn(['trees', treeKey, 'tree', 'nodes', id]).updateIn(['trees', treeKey, 'tree', 'connectors'], function (connectors) {
      return connectors.filter(function (connector) {
        return connector.headId !== id && connector.tailId !== id;
      });
    });
  },
  TREE_ADD_CONNECTOR: function TREE_ADD_CONNECTOR(state, _ref18) {
    var _ref18$payload = _ref18.payload,
        treeKey = _ref18$payload.treeKey,
        headId = _ref18$payload.headId,
        tailId = _ref18$payload.tailId;
    return remember(state, treeKey).updateIn(['trees', treeKey, 'tree'], function (tree) {
      return tree.update('connectors', function (connectors) {
        return connectors.set(tree.nextConnectorId, Connector({
          id: tree.nextConnectorId,
          headId: headId,
          tailId: tailId
        }));
      }).update('nextConnectorId', function (id) {
        return id + 1;
      });
    });
  },
  TREE_UPDATE_CONNECTOR: function TREE_UPDATE_CONNECTOR(state, _ref19) {
    var _ref19$payload = _ref19.payload,
        treeKey = _ref19$payload.treeKey,
        id = _ref19$payload.id,
        type = _ref19$payload.type,
        label = _ref19$payload.label,
        condition = _ref19$payload.condition;
    return state.hasIn(['trees', treeKey, 'tree', 'connectors', id]) ? remember(state, treeKey).mergeIn(['trees', treeKey, 'tree', 'connectors', id], {
      type: type,
      label: label,
      condition: condition
    }) : state;
  },
  TREE_REMOVE_CONNECTOR: function TREE_REMOVE_CONNECTOR(state, _ref20) {
    var _ref20$payload = _ref20.payload,
        treeKey = _ref20$payload.treeKey,
        id = _ref20$payload.id;
    return remember(state, treeKey).deleteIn(['trees', treeKey, 'tree', 'connectors', id]);
  },
  TREE_UPDATE_CONNECTOR_HEAD: function TREE_UPDATE_CONNECTOR_HEAD(state, _ref21) {
    var _ref21$payload = _ref21.payload,
        treeKey = _ref21$payload.treeKey,
        id = _ref21$payload.id,
        nodeId = _ref21$payload.nodeId;
    return remember(state, treeKey).setIn(['trees', treeKey, 'tree', 'connectors', id, 'headId'], nodeId);
  },
  TREE_UPDATE_CONNECTOR_TAIL: function TREE_UPDATE_CONNECTOR_TAIL(state, _ref22) {
    var _ref22$payload = _ref22.payload,
        treeKey = _ref22$payload.treeKey,
        id = _ref22$payload.id,
        nodeId = _ref22$payload.nodeId;
    return remember(state, treeKey).setIn(['trees', treeKey, 'tree', 'connectors', id, 'tailId'], nodeId);
  }
});